<template lang="pug">
  div
    .field.is-horizontal.min-height(
      v-tooltip="{content: tooltip, show: (showTooltip && !noExperience) }"
    )
      label.label.font.is-pulled-left {{ gettext('Work experience') }}
      .field-body.right
    .field.is-horizontal.min-height
      label.label.name
        span.radio-wrap.left
          input.is-checkradio.custom-checkbox-box#no-experience(
          type="checkbox"
          name="no-experience"
          v-model="noExperience"
          )
          label(for="no-experience") {{ gettext('I don`t have experience') }}
      .field-body
    transition(tag="div" name="fade")
      .exp-wrapper(v-if="!noExperience")
        .overlay
          .exp-wrap(:key="experience.id || index" v-for="(experience, index) in items")
            .work-experience

              .field.is-horizontal(v-if="$v.value.$each[index]")

                .ections-icons(v-if="items.length > 1")
                    i.mdi.mdi-close-box-outline.icon-delete(@click="remove(index)")
                .ections-icons(v-else)
                    i.mdi.mdi-minus-circle-outline.icon-delete(@click="remove(index)")

                label.label.name {{ gettext('Work period')+'*' }}
                .field-body.date-box(@click="validateData(index, 'period_from')")
                  div {{ gettext('From') }}
                  div
                    datepicker(
                    v-model="experience.period_from"
                    :inputClass="'input'"
                    :exclude="[`day`]"
                    :minAge="0"
                    :class="{'is-danger': $v.value.$each[index].period_from.$error, 'is-empty': !experience.period_from && !noExperience}"
                    :iso="true"
                    )
              .field.is-horizontal(v-if="$v.value.$each[index]")
                label.label.name
                .field-body.date-box(@click="validateData(index, 'period_to')")
                  div {{ gettext('To') }}
                  div
                    datepicker(
                    v-model="experience.period_to"
                    :inputClass="'input'"
                    :exclude="[`day`]"
                    :minAge="0"
                    :class="{'is-danger': $v.value.$each[index].period_to.$error, 'is-empty': !experience.period_to && !noExperience}"
                    :iso="true"
                    :present="true"
                    )

              .field.is-horizontal
                label.label.name {{ gettext('Company') }}
                .field-body
                  input.input(
                  name="company"
                  v-model="experience.company"
                  @input="experience.company = validateLatinCharacter($event)"
                  :placeholder="gettext('Only latin letters')"
                  )

              .field.is-horizontal(v-if="$v.value.$each[index]")
                label.label.name {{ gettext('Country')+'*' }}
                .field-body(@click="validateData(index, 'country')")
                  ajax-multiselect.is-single(
                  v-model="experience.country"
                  :labelText="gettext('Choose the country')"
                  returnItem ="id"
                  itemName ="name"
                  :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_work_xp']}}"
                  :class="{'is-danger': $v.value.$each[index].country.$error, 'is-empty': !experience.country && !noExperience}"
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                  )

              .field.is-horizontal(v-if="$v.value.$each[index]")
                label.label.name {{ gettext('Company branch')+'*' }}
                .field-body(@click="validateData(index, 'company_type')")
                  ajax-dropdown.wide(
                  v-model="experience.company_type"
                  :labelText="gettext('Choose the company type')"
                  :itemName ="'name'"
                  :returnItem ="'id'"
                  :action="{method: 'receiveCompanyTypes', params:{lang: getLanguage, country: experience.country}}"
                  :class="{'is-danger': $v.value.$each[index].company_type.$error, 'is-empty': !experience.company_type && !noExperience}"
                  :disabled="!experience.country"
                  @updated="dropdownSelected(index, 'company_sector', 'company_sector', 'profession')"
                  )

              .field.is-horizontal(v-if="$v.value.$each[index]")
                label.label.name {{ gettext('Company sector')+'*' }}
                .field-body(@click="validateData(index, 'company_sector')")
                  ajax-dropdown.wide(
                  v-model="experience.company_sector"
                  :labelText="gettext('Choose the company sector')"
                  :itemName ="'name'"
                  :returnItem ="'id'"
                  :action="{method: 'receiveCompanySectors', params:{lang: getLanguage, type: experience.company_type}}"
                  :class="{'is-danger': $v.value.$each[index].company_sector.$error, 'is-empty': !experience.company_sector && !noExperience}"
                  :disabled="!experience.company_type"
                  @updated="dropdownSelected(index, 'profession')"
                  )

              .field.is-horizontal(v-if="$v.value.$each[index]")
                label.label.name {{ gettext('Profession')+'*' }}
                .field-body(@click="validateData(index, 'profession')")
                  ajax-dropdown.wide(
                  v-model="experience.profession"
                  :labelText="gettext('Choose the profession')"
                  :itemName ="'name'"
                  :option="gettext('Other')"
                  :returnDefault="true"
                  :action="{method: 'receiveWorkProfessions', params:{lang: getLanguage, sector: experience.company_sector}}"
                  :class="{'is-danger': $v.value.$each[index].profession.$error, 'is-empty': !experience.profession && !noExperience}"
                  :disabled="!experience.company_sector"
                  )

              .field.is-horizontal(v-if="$v.value.$each[index] && (experience.profession || {}).default")
                label.label.name {{ gettext('Position')+'*' }}
                .field-body
                  input.input(
                  name="position"
                  v-model="experience.position"
                  @input="experience.position = validateLatinCharacter($event)"
                  :placeholder="gettext('Only latin letters')"
                  @blur="validateData(index, 'position')"
                  :class="{'is-danger': $v.value.$each[index].position.$error, 'is-empty': !experience.position && !noExperience}"
                  )

              .field.is-horizontal.vertical(v-if="$v.value.$each[index]")
                label.label.name {{ gettext('Describe your work') }}
                .field-body
                  textarea.textarea(
                    v-tooltip="{content: gettext('Max 2048 characters'), show: ($v.value.$each[index].responsibilities.$error) }"
                    v-model="experience.responsibilities"
                    rows="7"
                    :placeholder="gettext('Only latin letters')"
                    @input="experience.responsibilities = validateLatinCharacter($event), validateData(index, 'responsibilities')"
                    :class="{'is-danger': $v.value.$each[index].responsibilities.$error, 'disabled': !experience.company_type, 'is-empty': !experience.responsibilities && !noExperience}"
                  )
            .field.is-horizontal.linned-bottom.min-height(v-if="items.length !== index+1")
              label.label.name
              .field-body

        .field.is-horizontal.field-add
          label.label
          .field-body
            .add(@click="add")
              i.mdi.mdi-plus-box.icon-plus
              span {{ gettext('Add another experience') }}
</template>

<script>
import Vue from 'vue'
import {gettext} from '@/services/TranslateHandler'
import {mapGetters} from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import Datepicker from '@/components/datepicker'
import AjaxMultiselect from '@/components/ajax-multiselect'
import Vuelidate from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import mixin from '@/mixins'

Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

Vue.use(Vuelidate)

const _ = require('lodash')

export default {
  name: 'WorkExperience',
  mixins: [mixin],
  data () {
    return {
      noExperience: false,
      showTooltip: false,
      defaultValue: {
        id: 1,
        period_from: '',
        period_to: '',
        company: '',
        country: '',
        profession: '',
        position: '',
        company_type: '',
        company_sector: '',
        responsibilities: ''
      }
    }
  },
  props: {
    experience: {
      default: true
    },
    defaultItem: {
      default: 0
    },
    value: {
      default: () => {
        return []
      }
    },
    tooltip: {
      default: ''
    }
  },
  components: {
    AjaxDropdown,
    AjaxMultiselect,
    Datepicker
  },
  validations: {
    value: {
      $each: {
        period_from: {required},
        period_to: {required},
        country: {required},
        profession: {required},
        position: {
          required: function (data, current) {
            if ((current.profession || {}).default && !data.length) return false
            return true
          }
        },
        company_type: {required},
        company_sector: {required},
        responsibilities: {maxLength: maxLength(2048)}
      }
    }
  },
  methods: {
    gettext: gettext,
    remove (item) {
      this.items.splice(item, 1)
      this.$v.value.$reset()
    },
    add () {
      this.defaultValue.id++
      this.items = Object.assign({id: this.defaultValue.id}, this.defaultValue)
      this.$v.value.$reset()
    },
    clear (index, ...fields) {
      for (let item of fields) {
        this.$props['value'][index][item] = ''
      }
    },
    dropdownSelected (index, watch, ...clear) {
      this.clear(index, ...clear)
    },
    validateData (index, attr) {
      if (index || attr) {
        this.$v.value.$each[index][attr].$touch()
        if (this.$v.$anyError) {
          this.showTooltip = true
        }
        setTimeout(() => {
          this.showTooltip = false
        }, 5000)
      } else {
        this.$v.$touch()
        if (this.$v.$anyError) {
          this.showTooltip = true
        }
        setTimeout(() => {
          this.showTooltip = false
        }, 5000)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    items: {
      get: function () {
        if ((this.value.length < 1)) {
          return [
            {
              id: 0,
              period_from: '',
              period_to: '',
              company: '',
              country: '',
              profession: '',
              position: '',
              company_type: '',
              company_sector: '',
              responsibilities: ''
            }
          ]
        } else {
          return this.value
        }
      },
      set: function (value) {
        if (this.value.length > 0) {
          this.value.push(value)
        } else {
          _.each(this.items, item => {
            this.value.push(item)
          })
          this.value.push(value)
        }
      }
    },
    formIsValid: function () {
      return !this.$v.$invalid
    }
  },
  watch: {
    items: {
      deep: true,
      handler: function (value) {
        this.$emit('input', value)
      }
    },
    noExperience: function (val) {
      this.$emit('experience', !val)
      if (val) {
        this.$v.$reset()
        this.$emit('input', [])
      }
    },
    formIsValid: function (val) {
      if (val) this.$emit('valid', val)
    },
    experience: function (val) {
      if (!val) this.noExperience = !val
    }
  },
  created () {
    this.$emit('input', this.items)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/profile/cvs/cv/parts/work-experience/index.vue